import { FC } from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import ProductPrice from '@base/snippets/ProductPriceV2';
import { IVariant } from 'base/interfaces/product';

export  type IProdTabItem = {
    key: string;
    title: string | boolean;
    content: React.ReactElement;
    positionIndex?: number;      // 记录位置 (比较是否展示)
};

type IProdTabsProps = {
    tabList: IProdTabItem[];
    shownVariant: IVariant;
    activeIndex: number;
    setActiveIndex: (index: number) => void;
};

export const ProdTabs: FC<IProdTabsProps> = props => {
    const { tabList, activeIndex, setActiveIndex } = props;
    return tabList.length === 0 ? null : (
        <div className={cn('wrapper', styles.tabs)}>
            {tabList.length > 1 && (
                <div className={cn('flex', styles['tab-bar-nav'])}>
                    {tabList?.filter(item => !!item.title)?.map((item, index) => (
                        <div
                            key={item.key}
                            onClick={() => setActiveIndex(item?.positionIndex as number || 0)}
                            className={cn(
                                'flex-1',
                                { [styles.active]: activeIndex === item.positionIndex }
                            )}
                        >
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
            )}

            {tabList.map((item, index) => (
                <div
                    key={index}
                    className={cn(
                        styles['tab-part'],
                        { [styles['show-part']]: (activeIndex <= (item?.positionIndex || 0)) }
                    )}
                >
                    <>{item.content}</>
                </div>
            ))}
        </div>
    )
};
